module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/barkingham-700.06dcd909f1a89f72.jpg"+" 700w",
        images: [{path: "https://static.sniffspot.com/packs/img/barkingham-700.06dcd909f1a89f72.jpg",width: 700,height: 686}],
        src: "https://static.sniffspot.com/packs/img/barkingham-700.06dcd909f1a89f72.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/barkingham-700.06dcd909f1a89f72.jpg"},
        
        width: 700,
        height: 686
      }